import { render, staticRenderFns } from "./MoFooter.vue?vue&type=template&id=7c3a26f6&scoped=true&"
import script from "./MoFooter.vue?vue&type=script&lang=js&"
export * from "./MoFooter.vue?vue&type=script&lang=js&"
import style0 from "./MoFooter.vue?vue&type=style&index=0&id=7c3a26f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a26f6",
  null
  
)

export default component.exports